import { animate, state, style, transition, trigger, AnimationTriggerMetadata, } from '@angular/animations';

export const popupMenuAnimations: {
    readonly showMenu: AnimationTriggerMetadata
} = {
    showMenu: trigger('showHide', [
        state(
            'show',
            style({
                opacity: 1,
                visibility: 'visible',
                height: '{{ height }}px'
            }),
            { params: { height: '90' } }
        ),
        state(
            'hide',
            style({
                opacity: 0,
                visibility: 'hidden',
                height: '0'
            })
        ),
        transition('show => hide', [
            animate('0.5s cubic-bezier(0.35, 0, 0.25, 1)')
        ]),
        transition('hide => show', [
            animate('0.5s cubic-bezier(0.35, 0, 0.25, 1)')
        ])
    ])
};

export type PopupMenuAnimationState = 'show' | 'hide';
